<div class="shift-compliance-container">
	<div
		class="
			d-flex
			flex-column flex-lg-row
			justify-content-between
			align-items-center
		"
	>
		<img
			class="shift-compliance-left"
			src="../assets/img/data-protection.svg"
			alt=""
		/>

		<div class="shift-compliance-right">
			<h1 class="shift-compliance-header">
				End-to-End Compliance <br class="d-none d-sm-block" />
				Data Security
			</h1>
			<p class="shift-compliance-para mt-4">
				Best-in-class security for the most risk-averse and
				<br class="d-none d-sm-block" />
				demanding environments.
			</p>
		</div>
	</div>
</div>
